<p-tree
  class="key-account-tree"
  [ngClass]="{ 'key-account-single-selection': !hasAllowMulipleSelection }"
  [value]="filteredTreeNodeList"
  [selectionMode]="!hasAllowMulipleSelection ? 'single' : 'checkbox'"
  [(selection)]="selectedNodeKeyAccount"
  (onNodeSelect)="onSelectionChange($event)"
  (onNodeUnselect)="onNodeUnselect($event)"
>
  <ng-template pTemplate="header">
    <div class="custom-search-container">
      <app-search-input
        [iconName]="'icon-search'"
        (searchTextChange)="onCustomFilterChange($event)"
      ></app-search-input>
    </div>
    <div class="select-all-container" *ngIf="hasAllowMulipleSelection">
      <p-checkbox
        [(ngModel)]="selectAll"
        [binary]="true"
        (onChange)="onSelectAllChange($event)"
        inputId="selectAll"
      />
      <label for="selectAll" class="select-all-label">{{ 'SHARED.SELECT_ALL' | translate }}</label>
    </div>
  </ng-template>

  <ng-template let-node pTemplate="default">
    <div class="flex align-items-center gap-2">
      <p-radioButton
        *ngIf="!hasAllowMulipleSelection && !node.children?.length"
        name="treeSelection"
        [value]="node"
        [ngModel]="selectedNodeKeyAccount"
        (onClick)="onRadioButtonClick(node, $event)"
      >
      </p-radioButton>
      <div class="custom-tree-node">
        <span class="node-label">{{ node.label }}</span>
        <span class="node-parent-label" *ngIf="node.data?.parentLabel">
          {{ node.data.parentLabel }}
        </span>
      </div>
    </div>
  </ng-template>
</p-tree>
